import { render, staticRenderFns } from "./WarningLimitPackage.vue?vue&type=template&id=963cd320&"
import script from "./WarningLimitPackage.vue?vue&type=script&lang=js&"
export * from "./WarningLimitPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports